import { ReviewCheck, StyleSparkle, Verified, WatchPlay } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';

export const getFeatures = (storageQuota?: string | null) => {
  const storageDescription = storageQuota
    ? translate({
        singular: '{STORAGE} of storage, 4K ultra-HD, and our always ad-free player',
        replacements: { STORAGE: storageQuota },
      })
    : translate('Lots of storage, 4K ultra-HD, and our always ad-free player');

  return [
    {
      Icon: <StyleSparkle />,
      title: translate('Make your videos shine'),
      description: storageDescription,
    },
    {
      Icon: <WatchPlay />,
      title: translate('Showcase your work'),
      description: translate('Embeddable video portfolio with customizable layouts and designs'),
    },
    {
      Icon: <ReviewCheck />,
      title: translate('Streamline feedback and approvals'),
      description: translate('Time-coded comments and easy downloads for coworkers and clients'),
    },
    {
      Icon: <Verified />,
      title: translate('Cancel anytime'),
      description: translate('We’ll remind you before your trial ends'),
    },
  ];
};
